import { render, staticRenderFns } from "./problem-report-list-row.vue?vue&type=template&id=58a4abb2"
import script from "./problem-report-list-row.vue?vue&type=script&lang=js"
export * from "./problem-report-list-row.vue?vue&type=script&lang=js"
import style0 from "./problem-report-list-row.vue?vue&type=style&index=0&id=58a4abb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports